import Vue from 'vue'
import { ActionTree, GetterTree, MutationTree } from "vuex"

import { RootState } from "~/store/store.types"
import { PagesState } from "~/store/pages/pages.types"
import { SohoApiModel, SohoModel } from "~/constants/SohoModel"
import get from '~/helpers/get'

export const SitecoreApi = {
  placeholder: `${SohoApiModel[SohoModel.Sitecore]}/api/layout/placeholder/jss`
}

export const BOOKING_TERMS_AND_CONDITIONS_IDS  = {
  PLACEHOLDER_ID: '1322750D-B2B1-482A-81D7-A73D0D532A02',
  PART_ONE_ID: 'ba659bd2-656c-4315-9491-178da1bece51',
  PART_TWO_ID:  '4ac2d9d8-3395-4e0e-8df6-5be5911e986e'
}

export const BOOKING_POLICY_IDS = {
  PLACEHOLDER_ID: 'CEC2DF1B-B44A-484C-AFBD-EFD60E07302B',
  POLICY_ID: '870c7899-d44b-412e-b7ff-bcd02b263f6e'
}

export const state = (): PagesState => ({
  data: {},
  filters: {}
})

export const getters: GetterTree<PagesState, RootState> = {
  extractPlaceholderText (state, getters) {
    return (id: string, items: string[]) => {
      if (getters.isResourceAvailable(id)) {
        return items.map(uid => {
          const [ item ] = state.data[id].filter(item => item.uid === uid)
          return get(item, 'fields.text.value', null)
        }).join(' ')
      }

      return null
    }
  },

  isResourceAvailable (state) {
    return (id: string) => {
      return !!state.data[id]
    }
  }
}

export const mutations: MutationTree<PagesState> = {
  SET_PAGE (state, { id, elements }) {

    Vue.set(state.data, id, elements)
  }
}

export const actions: ActionTree<{}, RootState> = {
  async fetchPage ({ commit }, { id }) {
    const { data: { elements }} = await this.$axios.get(SitecoreApi.placeholder, {
      params: {
        sc_lang: this.$i18n.locale,
        placeholderName: 'digital-house-main',
        item: `{${id}}`
      }
    })

    commit('SET_PAGE', { id, elements })
  }
}
